import React from "react";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import PlatformsMarquee from "@/components/PlatformsMarquee";
import WhyGigAfloat from "@/components/WhyGigAfloat";
import FeaturesBento from "@/components/FeaturesBento";
import HowItWorks from "@/components/HowItWorks";
import MobileShowcase from "@/components/MobileShowcase";
import Stats from "@/components/Stats";
import Testimonials from "@/components/Testimonials";
import FAQ from "@/components/FAQ";
import FinalCTA from "@/components/FinalCTA";
import SocialConnect from "@/components/SocialConnect";
import Footer from "@/components/Footer";

const Landing = () => (
  <div className="bg-[#050505] text-white" data-testid="landing-page">
    <Nav />
    <main>
      <Hero />
      <PlatformsMarquee />
      <WhyGigAfloat />
      <HowItWorks />
      <FeaturesBento />
      <MobileShowcase />
      <Stats />
      <Testimonials />
      <FAQ />
      <FinalCTA />
      <SocialConnect />
    </main>
    <Footer />
  </div>
);

export default Landing;
